import { Id } from '@shared/types/id';
import { FileModel } from '@features/file/models/file-model';

export class Sequence {
  constructor(
    readonly id: Id,
    readonly name: string,
    readonly description: string,
    readonly createdAt: Date,
    readonly generatedAt: Date,
    readonly file: FileModel,
    readonly convertedSequence: string
  ) {}
}
